export default [
  {
    path: '/sales',
    name: 'SalesList',
    component: () => import('pages/sales/list/SalesList.vue')
  }
]
